import { QueryClient, QueryFunction } from "@tanstack/react-query";
const API_URL = import.meta.env.VITE_API_URL || '';
export const API_BASE_URL = API_URL;

async function throwIfResNotOk(res: Response) {
  if (!res.ok) {
    const text = (await res.text()) || res.statusText;
    throw new Error(`${res.status}: ${text}`);
  }
}

// Recupera o token salvo localmente
function getAuthHeaders(): HeadersInit {
  const token = localStorage.getItem("auth_token");
  return token
    ? {
        "Authorization": `Bearer ${token}`,
        "Accept": "application/json",
        "Content-Type": "application/json",
      }
    : {
        "Accept": "application/json",
        "Content-Type": "application/json",
      };
}

export async function apiRequest(
  method: string,
  url: string,
  data?: unknown
): Promise<Response> {
  console.log(`Realizando requisição ${method} para ${url}`);

  const res = await fetch(`${API_BASE_URL}${url}`, {
    method,
    headers: getAuthHeaders(),
    body: data ? JSON.stringify(data) : undefined,
    mode: "cors",
    credentials: "include",
  });

  console.log(`Resposta de ${url}: Status ${res.status}`);

  // Não lança erro para respostas 401 em operações de login
  if (url.endsWith("/login") && method === "POST") {
    return res;
  }

  await throwIfResNotOk(res);
  return res;
}

type UnauthorizedBehavior = "returnNull" | "throw";

export const getQueryFn: <T>(options: {
  on401: UnauthorizedBehavior;
}) => QueryFunction<T> =
  ({ on401: unauthorizedBehavior }) =>
  async ({ queryKey }) => {
    const url = queryKey[0] as string;
    console.log(`getQueryFn - Consultando: ${url}`);

    const res = await fetch(`${API_BASE_URL}${url}`, {
      method: "GET",
      headers: getAuthHeaders(),
      mode: "cors",
        credentials: "include",
    });

    console.log(`getQueryFn - Resposta de ${url}: Status ${res.status}`);

    if (unauthorizedBehavior === "returnNull" && res.status === 401) {
      console.log(`getQueryFn - Retornando null para status 401 em ${url}`);
      return null;
    }

    await throwIfResNotOk(res);
    const data = await res.json();
    console.log(`getQueryFn - Dados recebidos de ${url}:`, data);
    return data;
  };

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryFn: getQueryFn({ on401: "returnNull" }),
      refetchInterval: false,
      refetchOnWindowFocus: false,
      staleTime: 30000,
      retry: false,
    },
    mutations: {
      retry: false,
    },
  },
});